import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { IS_DAILY_PUBLISHING, PUBLISH_NOW, UPDATE_DAILY_PUBLISHING } from "../../../graphql/publish-gql";
import { notifySuccess } from "../../../services/notification";
import { PublishIcon, SaveIcon } from "../../common/icons";
import LabelCol from "../../common/label-col";
import confirm from "../../common/confirm";
import SpinnerOverlay from "../../common/spinner/spinner";

const PublishForm = () => {
    const [dailyPublishing, setDailyPublishing] = useState<boolean>();

    const [getDailyPublishing, { data, loading }] = useLazyQuery<{ isDailyPublishing: boolean }>(IS_DAILY_PUBLISHING, {
        onCompleted: (data) => {
            setDailyPublishing(data.isDailyPublishing)
        }
    })

    const [updatePublish, { loading: updating }] = useMutation<{ updateDailyPublishing: boolean }>(UPDATE_DAILY_PUBLISHING)

    const [publishNow, { loading: publishing }] = useMutation<{ publishNow: boolean }>(PUBLISH_NOW)

    useEffect(() => {
        getDailyPublishing()
    }, [])

    const handleSubmit = (event: any) => {
        event.preventDefault()

        updatePublish({
            variables: {
                enabled: dailyPublishing
            },
            refetchQueries: [{
                query: IS_DAILY_PUBLISHING
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                data && notifySuccess()
            }
        })
    }

    const handleChange = (event: any) => {
        setDailyPublishing(event.target.value === 'true')
    }

    const onPublishNow = () => {
        confirm({
            title: 'Publish Now?',
            content: 'Latest changes (outside of scheduled daily publishing) will be published now. The publication process may take a few hours. <br/>Do you want to continue?',
            okText: <><PublishIcon/> Publish</>,
            okBtnColor: 'danger'
        }).then(() => {
            publishNow({
                onCompleted: (data) => {
                    data && notifySuccess()
                }
            });
        })
    }

    return  <>
         {(loading || updating || publishing) && <SpinnerOverlay />}
        <Form onSubmit={handleSubmit} className="oms-container">
            <Row>
                <LabelCol className="col-auto">Daily Publishing:</LabelCol>
                <LabelCol className="col-auto ps-5">
                    <FormGroup check>
                        <Input id="daily_publishing_on" type="radio" name="dailyPublishing" value="true"
                            checked={dailyPublishing === true} onChange={handleChange} />
                        {' '}
                        <Label for="daily_publishing_on" check>Yes</Label>
                    </FormGroup>
                </LabelCol>
                <LabelCol className="col-auto pe-5">
                    <FormGroup check>
                        <Input id="daily_publishing_off" type="radio" name="dailyPublishing" value="false"
                            checked={dailyPublishing === false} onChange={handleChange} />
                        {' '}
                        <Label for="daily_publishing_off" check>No</Label>
                    </FormGroup>
                </LabelCol>
                <Col className="col-auto">
                    <Button type="submit" color="primary">
                        <SaveIcon /> Save Changes
                    </Button>
                </Col>
            </Row>

            <Row>
                <Col className="col-auto">
                    <Button color="danger" onClick={onPublishNow} >
                        <PublishIcon /> Publish Now
                    </Button>
                </Col>
            </Row>
        </Form>
    </>
}

export default PublishForm